
  import LkAccessOverlay from '@/components/org/LkAccessOverlay.vue'
  import ForcePasswordChangeModal from '@/components/auth/ForcePasswordChangeModal.vue'
  import {
    cabinetAppearanceVars,
    setDocumentAppearanceVars,
  } from '@/utils/orgAccent'

  export default {
    components: {
      LkAccessOverlay,
      ForcePasswordChangeModal,
    },
    head: {
      meta: [
        {
          hid: 'robots',
          name: 'robots',
          content: 'noindex, nofollow',
        },
      ],
    },
    computed: {
      cabinetAppearanceStyle() {
        return cabinetAppearanceVars(this.$store.state.org?.currentOrg)
      },
      mustChangePassword() {
        return this.$store.getters['auth/mustChangePassword']
      },
    },
    watch: {
      cabinetAppearanceStyle: {
        handler(vars) {
          setDocumentAppearanceVars(vars)
        },
        immediate: true,
        deep: true,
      },
    },
    mounted() {
      this.$store.dispatch('auth/loadAuthData')
    },
    beforeDestroy() {
      setDocumentAppearanceVars({})
    },
  }
